export default __webpack_public_path__ + "static/media/pic1.c6eaf9da.png";